var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tableRenderWrap",staticClass:"wrap"},[_c('complete-table',{ref:"table",scopedSlots:_vm._u([{key:"operator",fn:function(){return undefined},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }